/**
 * Citation-map helpers for import_chunk (#632).
 *
 * Existing maps stay short-id → UUID (message / summary / bookmark).
 * Typed entries are { id, kind }. Only kind import_chunk opens the
 * source viewer. Search (#633) emits these from Explore, Focus,
 * Book Notes, and Dossiers.
 */

export const IMPORT_CHUNK_KIND = 'import_chunk';

export function citationShortId(fullId) {
  if (!fullId) return '';
  return String(fullId).replace(/-/g, '').slice(0, 8);
}

/**
 * @returns {{ chunkId: string, explicit: boolean } | null}
 */
export function resolveImportChunkTarget(shortId, citationData) {
  if (citationData && typeof citationData === 'object') {
    if (citationData.kind === IMPORT_CHUNK_KIND) {
      const chunkId = citationData.id || citationData.fullId;
      return chunkId ? { chunkId, explicit: true } : null;
    }
    if (citationData.kind) {
      return null;
    }
  }
  return null;
}

export function speakerLabel(role) {
  if (role === 'user') return 'You';
  if (role === 'assistant') return 'Brainstormy';
  return null;
}

export function formatLabel(declaredFormat) {
  if (declaredFormat === 'outline') return 'Outline';
  if (declaredFormat === 'flat_notes') return 'Loose pages';
  if (declaredFormat === 'transcript') return 'Pasted AI chat transcript';
  if (declaredFormat === 'manuscript_draft') return 'Manuscript draft';
  if (declaredFormat === 'story_sheet') return 'Story sheet from outside chat';
  return declaredFormat || 'Imported document';
}
